import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/globalMasterDetails`;

export const getInventoryStatuses = async () => {
  try {
    const response = await axios.get(`${API_BASE}?inventoryType=inventoryStatus`);
    const data = response.data;
    const statuses = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        booked: item.details.booked || "N/A",
        available: item.details.available || "N/A",
        underConstruction: parseInt(item.details.underConstruction) || 0,
        hold: item.status ? "Active" : "Inactive",
      }))
      : [];
    return statuses;
  } catch (error) {
    console.error("Error fetching inventory statuses:", error);
    return [];
  }
};

export const createInventoryStatus = async (payload) => {
  try {
    const response = await axios.post(`${API_BASE}?inventoryType=inventoryStatus`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateInventoryStatus = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}?inventoryType=inventoryStatus`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteInventoryStatus = async (id) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}?inventoryType=inventoryStatus`, { isDeleted: true });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getDesignations = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=designation`);
    const data = response.data;
    const designations = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          name: item.details.designationName || "N/A",
          value: item.details.designationName || "",
          fromAmount: item.details.fromAmount || 0,
        }))
      : [];
    return designations;
  } catch (error) {
    console.error("Error fetching designations:", error);
    return [];
  }
};

export const getBanks = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=bank`);
    const data = response.data;
    const banks = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          name: item.details?.bankName || "N/A",
          value: item.details?.bankName || "",
        }))
      : [];
    return banks;
  } catch (error) {
    console.error("Error fetching banks:", error);
    return [];
  }
};

export const getStates = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=state`);
    const data = response.data;
    const states = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          name: item.details?.stateName || "N/A",
          value: item.details?.stateName || "",
        }))
      : [];
    return states;
  } catch (error) {
    console.error("Error fetching states:", error);
    return [];
  }
};

export const getCities = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=city`);
    const data = response.data;
    const cities = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          name: item.details?.cityName || "N/A",
          value: item.details?.cityName || "",
          state: item.details?.state || "",
        }))
      : [];
    return cities;
  } catch (error) {
    console.error("Error fetching cities:", error);
    return [];
  }
};

export const getRoles = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=role`);
    const data = response.data;
    const roles = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          name: item.details?.roleName || "N/A",
          value: item.details?.roleName || "",
        }))
      : [];
    return roles;
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};

export const getFacings = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=facing`);
    const data = response.data;
    const facings = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        name: item.details?.facingName || 'Unknown',
        code: item.details?.facingCode || '',
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return facings;
  } catch (error) {
    console.error('Error fetching facings:', error);
    return [];
  }
};

export const createFacing = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateFacing = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteFacing = async (id) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getFlatTypes = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=flatType`);
    const data = response.data;
    const flatTypes = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        flatType: item.details?.flatType || item.details?.name || 'Unknown',
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return flatTypes;
  } catch (error) {
    console.error('Error fetching flat types:', error);
    return [];
  }
};

export const createFlatType = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateFlatType = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteFlatType = async (id) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getRowHouses = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=rowHouse`);
    const data = response.data;
    const rowHouses = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        rowHouse: item.details?.rowHouse || item.details?.name || 'Unknown',
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return rowHouses;
  } catch (error) {
    console.error('Error fetching row houses:', error);
    return [];
  }
};

export const createRowHouse = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateRowHouse = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteRowHouse = async (id) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getVillaTypes = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=villaType`);
    const data = response.data;
    const villaTypes = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        villaType: item.details?.villaType || item.details?.name || 'Unknown',
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return villaTypes;
  } catch (error) {
    console.error('Error fetching villa types:', error);
    return [];
  }
};

export const createVillaType = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateVillaType = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteVillaType = async (id) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLeadPriorities = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=leadPriority`);
    const data = response.data;
    const leadPriorities = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        leadPriorityId: item.details?.leadPriorityId || item._id.substring(0, 8).toUpperCase(),
        leadPriority: item.details?.leadPriority || item.details?.name || 'Unknown',
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return leadPriorities;
  } catch (error) {
    console.error('Error fetching lead priorities:', error);
    return [];
  }
};

export const createLeadPriority = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateLeadPriority = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteLeadPriority = async (id) => {
  try {
    console.log('Making delete request to:', `${API_BASE}/${id}`, 'with id:', id);
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    console.log('Delete response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Delete API error:', error.response?.data || error.message);
    throw error.response?.data || error.message;
  }
};

export const getLeadStatuses = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=leadStatus`);
    const data = response.data;
    const leadStatuses = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        leadStatusId: item.details?.leadStatusId || item._id.substring(0, 8).toUpperCase(),
        leadStatus: item.details?.leadStatus || item.details?.name || 'Unknown',
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return leadStatuses;
  } catch (error) {
    console.error('Error fetching lead statuses:', error);
    return [];
  }
};

export const createLeadStatus = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateLeadStatus = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteLeadStatus = async (id) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLeadInterested = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=projectType`);
    const data = response.data;
    const leadInterested = Array.isArray(data.data)
      ? data.data.map((item) => ({
        id: item._id,
        name: item.details?.projectType || "N/A",
        value: item.details?.projectType || "",
        leadInterested: item.details?.projectType || "",
        status: item.status === true ? 'Active' : 'Inactive',
        rawStatus: item.status,
      }))
      : [];
    return leadInterested;
  } catch (error) {
    console.error("Error fetching lead interested:", error);
    return [];
  }
};

export const createLeadInterested = async (payload) => {
  try {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateLeadInterested = async (id, payload) => {
  try {
    const response = await axios.put(`${API_BASE}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteLeadInterested = async (id) => {
  try {
    console.log('Making delete request to:', `${API_BASE}/${id}`, 'with id:', id);
    const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true });
    console.log('Delete response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Delete API error:', error.response?.data || error.message);
    throw error.response?.data || error.message;
  }
};

export const getCommissions = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=commission`);
    const data = response.data;
    const commissions = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status) // Filter out inactive items
        .map((item) => {
          // Extract commission percentage from details
          const commissionValue = Number(item.details?.commissionPercentage || 0);

          return {
            id: item._id,
            value: commissionValue,
            label: `${commissionValue}%`,
            commission: commissionValue,
          };
        })
        .filter((item) => item.commission > 0) // Only include valid commission values (> 0)
        .sort((a, b) => Number(a.commission) - Number(b.commission))
      : [];
    return commissions;
  } catch (error) {
    console.error('Error fetching commissions:', error);
    return [];
  }
};

export const getBudgets = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=budget`);
    const data = response.data;
    const budgets = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          budgetRange: item.details?.budgetRange || "N/A",
          value: item.details?.budgetRange || "",
        }))
      : [];
    return budgets;
  } catch (error) {
    console.error("Error fetching budgets:", error);
    return [];
  }
};
export const getSources = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=source`);
    const data = response.data;
    const sources = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          name: item.details?.sourceName || "Unknown",
          value: item.details?.sourceName || "",
        }))
      : [];
    return sources;
  } catch (error) {
    console.error("Error fetching sources:", error);
    return [];
  }
};
export const getInquiryStatuses = async () => {
  try {
    const response = await axios.get(`${API_BASE}?type=inquiryStatus`);
    const data = response.data;
    const inquiryStatuses = Array.isArray(data.data)
      ? data.data
        .filter((item) => item.status)
        .map((item) => ({
          id: item._id,
          statusName: item.details?.statusName || "Unknown",
          colorCode: item.details?.colorCode || "#9e9e9e",
          inquiryCode: item.details?.inquiryCode || "",
          stageType: item.details?.stageType || "",
        }))
      : [];
    return inquiryStatuses;
  } catch (error) {
    console.error("Error fetching inquiry statuses:", error);
    return [];
  }
};
